import React from 'react'
import styled from '@emotion/styled'

const GradientText = styled.div`
  background: ${({color}) => color};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;

export default GradientText;